<template>
  <div class="evaluate-model">
    <span class="top-text" v-if="isOpenSolveButton">当前客服是否解决了您的问题？</span>
    <div class="resolve-and-noresolve" v-if="isOpenSolveButton">
      <div :class="{ active: solveFlag }" @click="solveFlag = true">
        <template>
          <img
            src="../../assets/imgs/icon-comment-shang-active.png"
            v-if="solveFlag"
          />
          <img src="../../assets/imgs/icon-comment-shang.png" v-else />
        </template>
        已解决
      </div>
      <div :class="{ active: !solveFlag }" @click="solveFlag = false">
        <template>
          <img
            src="../../assets/imgs/icon-comment-xia-active.png"
            v-if="!solveFlag"
          />
          <img src="../../assets/imgs/icon-comment-xia.png" v-else />
        </template>
        未解决
      </div>
    </div>
    <span class="middle-text">请您对本次服务进行评价</span>
    <el-rate class="icon_rate" v-model="rate" :disabled="false" />
    <span class="comment-text">{{ StarName }}</span>
    <template v-if="rate != 5">
      <div class="comment-btns">
        <div
          :class="{ active: selectTags.includes(item.title) }"
          v-for="item in tags"
          :key="item.id"
          @click="selectTag(item.title)"
        >
          {{ item.title }}
        </div>
      </div>
      <textarea
        class="textarea"
        maxlength="140"
        v-model="evaluateContent"
        placeholder="请您对本次服务进行评价"
      />
    </template>

    <div class="primary-btn" @click.once="submit">提交评价</div>
  </div>
</template>

<script>
//用户评价弹窗
import service from "src/app/customer/service";
export default {
  data() {
    return {
      rate: 5, //选中星星数
      selectTags: [], //选中的评论标签
      evaluateContent: "", //用户评价内容
      solveFlag: true, //是否解决了问题flag
      count: 0 //点击次数
    };
  },
  computed: {
    ...mapState({
      currCustomer: state => state.currCustomer || {},
      evaluateConfig: state => state.evaluateConfig, //评论配置
      invitationEvaluateFlag: state => state.invitationEvaluateFlag,
      channelId: state => state.channelId
    }),
    tags() {
      //标签库
      const { evaluateTag, evaluateTagName } = this.evaluateConfig;
      const evaluateTagArray = evaluateTag.split(",") || [];
      const evaluateTagNameArray = evaluateTagName.split("&") || [];
      return evaluateTagArray.reduce((acc, s, i) => {
        return [
          ...acc,
          { title: evaluateTagNameArray[i] || "错误:缺少id对应标签", id: s }
        ];
      }, []);
    },
    StarName() {
      //对应的星级评语
      const evaluateStarName = _.get(
        this.evaluateConfig,
        "evaluateStarName",
        ""
      );
      return evaluateStarName.split("&")[this.rate - 1] || "无对应星级评语";
    },
    isOpenSolveButton() {
      //是否开启解决问题button
      return this.evaluateConfig.solveFlag;
    }
  },
  methods: {
    selectTag(title) {
      //选中评论标签
      if (!this.selectTags.includes(title)) {
        this.selectTags.push(title);
      } else {
        const index = this.selectTags.findIndex(value => value === title);
        this.selectTags.splice(index, 1);
      }
    },
    close() {
      //关闭弹窗
      this.$store.commit("setState", {
        invitationEvaluateFlag: false,
        visibleEvaluate: false
      });
    },
    submit() {
      //提交评论并关闭弹窗
      if (this.count == 0) {
        this.coount++;
        const params = {
          evaluateContent: this.evaluateContent,
          evaluateStar: this.rate,
          evaluateTag: this.selectTags.join(),
          solveFlag: this.solveFlag,
          channelId: this.channelId,
          invitationEvaluateFlag: this.invitationEvaluateFlag
        };
        service.addSatisfaction(params).then(() => {
          this.close();
          this.$message({
            message: "感谢您的评价",
            type: "success"
          });
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.mobile {
  .top-text {
    display: inline-block;
    margin-top: 22px;
    font-size: 12px;
    line-height: 17px;
    color: #787878;
  }
  .resolve-and-noresolve {
    display: flex;
    width: 235px;
    margin: 14px auto 0;
    justify-content: space-between;

    div {
      width: 110px;
      height: 35px;
      border-radius: 4px;
      line-height: 35px;
      background: var(--evaluate-solve-button);
      color: var(--evaluate-solve-icon);
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 4px;
        width: 18px;
      }
    }
  }
  .middle-text {
    display: inline-block;
    margin-top: 20px;
    font-size: 12px;
    line-height: 17px;
    color: #787878;
  }
  .icon_rate {
    margin-top: 12px;
    height: 40px;
    -webkit-appearance: none !important ;
    border: none !important;
    outline: none !important;
    /deep/ i {
      font-size: 40px;
    }
    /deep/ .el-icon-star-off {
      color: var(--evaluate-rate-icon) !important;
    }
    /deep/ .el-icon-star-on {
      color: var(--evaluate-rate-click) !important;
    }
  }

  .comment-text {
    display: inline-block;
    height: 17px;
    margin-top: 12px;
    font-size: 12px;
    line-height: 17px;
    color: #e39d04;
  }
  .comment-btns {
    display: flex;
    height: auto;
    justify-content: flex-start;
    margin: 20px 0 0px;
    flex-wrap: wrap;

    div {
      width: 159px;
      margin-bottom: 8px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      margin-right: 5px;
      background: #ffffff;
      color: #1e1e1e;
      border: 1px solid #ababab;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .textarea {
    width: 100%;
    height: 74px;
    padding: 5px;
    outline: none;
    border: 1px solid #dedede;
  }
  .primary-btn {
    width: 325px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    text-align: center;
    margin: 8px 0 0 0;
    background: var(--button-bg) !important;
    color: var(--button-text) !important;
    &:active {
      background: var(--button-click) !important;
      color: var(--button-text-click) !important;
    }
  }
}

.pc {
  .top-text {
    display: inline-block;
    margin-top: 14px;
    font-size: 14px;
    line-height: 20px;
    color: #787878;
  }
  .resolve-and-noresolve {
    display: flex;
    width: 235px;
    margin: 10px auto 0;
    justify-content: space-between;

    div {
      width: 110px;
      height: 35px;
      border-radius: 4px;
      line-height: 35px;
      background: var(--evaluate-solve-button);
      color: var(--evaluate-solve-icon);
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 4px;
        width: 18px;
      }
    }
  }
  .icon_rate {
    margin-top: 16px;
    height: 30px;
    /deep/ i {
      font-size: 35px;
    }
    /deep/ .el-icon-star-off {
      color: var(--evaluate-rate-icon) !important;
    }
    /deep/ .el-icon-star-on {
      color: var(--evaluate-rate-click) !important;
    }
  }
  .middle-text {
    display: inline-block;
    margin-top: 30px;
    font-size: 14px;
    line-height: 20px;
    color: #787878;
  }
  .comment-text {
    display: inline-block;
    margin-top: 10px;
    font-size: 12px;
    line-height: 17px;
    color: #787878;
  }
  .comment-btns {
    display: flex;
    height: auto;
    flex-wrap: wrap;
    margin: 30px 0 10px;
    justify-content: flex-start;

    div {
      width: 90px;
      height: 30px;
      margin: 5px;
      line-height: 30px;
      font-size: 12px;
      color: #1e1e1e;
      border: 1px solid #ababab;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .textarea {
    width: 100%;
    height: 74px;
    padding: 5px;
    outline: none;
    border: 1px solid #dedede;
  }
  .primary-btn {
    margin: 20px auto 0;
    width: 120px;
    height: 35px;
    line-height: 35px;
    border-radius: 4px;
    text-align: center;
    background: var(--button-bg) !important;
    color: var(--button-text) !important;
    &:active {
      background: var(--button-click) !important;
      color: var(--button-text-click) !important;
    }
  }
}
.active {
  background: var(--evaluate-solve-click) !important;
  color: var(--evaluate-solve-icon) !important;
}
</style>
